import { IStreet, Street } from "./street.model";
import { Domain } from "./domain.model";

export interface IJobOffer {
    name?: string;
    companyPresentation ?: string;
    photoLogo?: string;
    phoneNumber?: string
    offerDeadline?: Date;
    residenceCity?: string;
    residenceCountry?: string;
    indicatif?:any;
    descriptionOfOffer?: string;
    requiredProfile?: string;
    contractType ?: string;
    contactEmail?: string;
}
export class JobOffer implements IJobOffer {
    constructor(
        public name?: string, 
        public companyPresentation?: string,
        public photoLogo? :string,
        public phoneNumber?: string,
        public indicatif?: any,
        public offerDeadline?: Date,
        public residenceCity?: string,
        public residenceCountry?: string,
        public descriptionOfOffer?: string,
        public requiredProfile?: string,
        public contractType?: string,
        public contactEmail?: string,
    ){
        this.name = name;
        this.companyPresentation = companyPresentation;
        this.photoLogo = photoLogo;
        this.phoneNumber = phoneNumber;
        this.indicatif = indicatif;
        this.offerDeadline = offerDeadline;
        this.residenceCity = residenceCity;
        this.residenceCountry = residenceCountry;
        this.descriptionOfOffer = descriptionOfOffer;
        this.requiredProfile = requiredProfile;
        this.contractType = contractType;
        this.contactEmail = contactEmail;

    }

}